import { useMutation } from '@tanstack/react-query';

import { useHttpClient } from '~/hooks/useHttpClient';
import { sanitizeTagValue } from '~/utils/instrumentation';
import { createLogger } from '~/utils/logging';
import { ClientError } from '~/errors';

const log = createLogger('useVerifyEmailMutation');

export type VerifyEmailRequest = {
  token: string;
};

export function useVerifyEmailMutation() {
  const httpClient = useHttpClient();

  const { mutate, status } = useMutation({
    mutationFn: async (request: VerifyEmailRequest) => {
      log.debug('Verifying email token');
      await httpClient.post('/auth/verifyEmail', request);
      log.info('Email verified successfully');
    },
    onError: (err: Error) => {
      if (err instanceof ClientError) {
        // Ignore client errors — handled at call site.
      } else {
        log.error('Failed to verify email', {
          errorMessage: sanitizeTagValue(err.message),
        });
      }
    },
  });

  return { mutate, status };
}
